import { Card, Col, Row } from "reactstrap";
import { H3 } from "../../../AbstractElements";
import { BrowseArticles, knowledgearticle } from "../../../Constant";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { CategoryDataCardBody } from "./CategoryDataCardBody";

const CategoryData = () => {
  return (
    <Col sm="12">
      <div className="header-faq">
        <H3 className="mb-0">{knowledgearticle}</H3>
      </div>
      <Row>
        <Col sm="12">
          <Card>
            <CommonCardHeader title={BrowseArticles} />
            <CategoryDataCardBody />
          </Card>
        </Col>
      </Row>
    </Col>
  );
};
export default CategoryData;
